import { render, staticRenderFns } from "./ClockInSetting.vue?vue&type=template&id=07b3538c&"
import script from "./ClockInSetting.vue?vue&type=script&lang=ts&"
export * from "./ClockInSetting.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports